<template >
  <div id="packageModal" class="modal fade " tabindex="-1" aria-hidden="true" >
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Nuevo Embalaje</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
    </div>
    <div class="modal-body">
      <form ref='packagesForm' class="needs-validation h-100" novalidate>

          <div>
              <label>Nombre <span style="color:red">*</span></label>
              <input  v-model="localValue.name" class="form-control" type="text" maxLength="50" required />
          </div>
          <div>
              <label>Alto <span style="color:red">*</span></label>
              <input v-model="localValue.high" class="form-control" type="number" min="0" step="any" required/>
          </div>
          <div>
              <label>Largo <span style="color:red">*</span></label>
              <input v-model="localValue.long" class="form-control" type="number" min="0" step="any"  required/>
          </div>
          <div>
              <label>Ancho <span style="color:red">*</span></label>
              <input v-model="localValue.width" class="form-control" type="number" min="0" step="any"  required/>
          </div>
      </form>
    </div>
    <div class="modal-footer">
      <button id="close" type="button" class="btn  btn-outline-primary" data-bs-dismiss="modal" @click="hideModal">Cerrar</button>
      <button type="button" class="btn bg-gradient-success" @click="guardar">Aceptar</button>
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  emits: ['new-package'],
  data() {
      return {
          localValue:{
            name:"",
            high: 0,
            long: 0,
            width: 0
          },
      }
  },
  methods: {
      hideModal() {
        this.$refs.packagesForm.classList.remove('was-validated');
        this.localValue.name='';
        this.localValue.high=0;
        this.localValue.long=0;
        this.localValue.width=0;
        document.getElementById('close').click();
      },
      guardar(){
        let form = this.$refs.packagesForm;
        form.classList.add('was-validated');
        if (form.checkValidity()) {
          this.$emit('new-package', this.localValue);
          this.hideModal();
      }
      }
  },

};
</script>

